import css from './AI.module.scss';
export default function ListOfWords({ title, words }) {
  return <div className={css.listOfWordsBox}>
    <div className={css.listOfWordsHeading}>
      {title}
    </div>
    <div className={css.listOfWords}>
      {words.map((word, index) => <div key={index} className={css.listOfWordsItem}>
        {word}
      </div>)}
    </div>
  </div>
}